// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shippingAddressStyles } from "@eisinc/Overrides/Widgets/CheckoutShipping/ShippingAddress";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { css } from "styled-components";

shippingAddressStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

shippingAddressStyles.headingGridItem = {
    css: css`
        display: flex;
        gap: 10px 20px;
        flex-wrap: wrap;
    `,
};

shippingAddressStyles.headingText = {
    variant: "h4",
    css: css`
        margin-bottom: 0;
    `,
};

shippingAddressStyles.selectSavedAddressLink = {
    typographyProps: {
        size: fontConfig.singleLinexSmall.size,
        lineHeight: fontConfig.singleLinexSmall.lineHeight,
    },
};

shippingAddressStyles.addressDisplayAndFormGridItem = {
    css: css`
        display: flex;
        flex-direction: column;
        margin-top: 4px;
    `,
};
